"use client"

import type React from "react"
import { Button } from "../button"
import { ChevronLeft, ChevronRight } from "lucide-react"

interface AssessmentNavigationProps {
  onPrevious: () => void
  onNext: () => void
  canGoPrevious: boolean
  canGoNext: boolean
  isAnimating: boolean
  isLastQuestion: boolean
  currentQuestion: number
  totalQuestions: number
}

export const AssessmentNavigation: React.FC<AssessmentNavigationProps> = ({
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext,
  isAnimating,
  isLastQuestion,
  currentQuestion,
  totalQuestions,
}) => {
  return (
    <div className="flex justify-between items-center pt-6 border-t border-slate-200">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={!canGoPrevious || isAnimating}
        className="flex items-center gap-2 bg-transparent"
      >
        <ChevronLeft className="w-4 h-4" />
        Previous
      </Button>

      <div className="text-sm font-medium text-slate-600 bg-slate-100 px-4 py-2 rounded-full">
        {currentQuestion} / {totalQuestions}
      </div>

      <Button
        onClick={onNext}
        disabled={!canGoNext || isAnimating}
        className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white"
      >
        {isLastQuestion ? "See Results!" : "Next"}
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  )
}
